import { ApiCallWithErrorHandling, FilterValueDto } from "../../../Business/Common/CommonBusiness";
import { LogApi } from "../../../Business/LogUndo";
import { GET_FILTER_LOG_UNDO, GET_LOG_UNDO, Log, LogGrid, LogQuery, LogQueryResultDto } from "../../../Model/Log";
import { rootStore } from "../../Store/rootStore";

export const GetLogUndo = async (query: LogQuery) => {
    let api = new LogApi();
    let data = await ApiCallWithErrorHandling(() => api.GetGrid(query));
    rootStore.dispatch({ type: GET_LOG_UNDO, payload: { LogGridResult: data, filter: null } as LogGrid });
}



export async function GetFilterColumnLogUndo(columName: string, columValue: string, queryFilter?: LogQuery) {
    let result: FilterValueDto[] | undefined;
    let api = new LogApi();

    if (queryFilter !== null && queryFilter !== undefined) {
        result = await ApiCallWithErrorHandling<Promise<FilterValueDto[]>>(() => api.LogGetFilterResult(columName, columValue, queryFilter));
    } else {
        result = await ApiCallWithErrorHandling<Promise<FilterValueDto[]>>(() => api.LogGetFilterResult(columName, columValue));
    }
    let rtn = { filter: result, LogGridResult: null } as LogGrid;
    rootStore.dispatch({ type: GET_FILTER_LOG_UNDO, payload: rtn });
}